import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import axios from 'axios';

export interface CariData {
  CariKod: string;
  CariIsim: string;
  Telefon: string;
  Adres: string;
  Ilce: string;
  Il: string;
  Ulke: string;
  VergiDairesi: string;
  VergiNo: string;
  Borc: number;
  Alacak: number;
  Bakiye: number;
  CariRisk: number;
  Email: string;
  TaksitSayisi: number;
}

interface CustomerState {
  customers: CariData[];
  selectedCustomer: CariData | null;
  customerDetail: CariData | null;
  error: string | null;
  isLoading: boolean;

  fetchCustomers: () => Promise<void>;
  setSelectedCustomer: (cari: CariData | null) => void;
  fetchCustomerDetail: (cariKod: string) => Promise<void>;
  getInstallmentData: () => { installmentCount: number };
}

const useCustomerStore = create<CustomerState>()(
  persist(
    (set, get) => ({
      customers: [],
      selectedCustomer: null,
      customerDetail: null,
      error: null,
      isLoading: false,

      fetchCustomers: async () => {
        try {
          set({ isLoading: true, error: null });

          const listUrl = 'https://bastas.duyu.alter.net.tr/PaymentCustomerGetList';
          const formData = new FormData();
          formData.append('Token', 'RasyoIoToken2021');

          const response = await axios.post<CariData[]>(listUrl, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          set({ customers: response.data, isLoading: false });
        } catch (err: any) {
          set({
            error: err.message || 'Müşteri listesi çekilirken hata oluştu',
            isLoading: false
          });
        }
      },

      setSelectedCustomer: (cari) => {
        set({ selectedCustomer: cari });
      },

      fetchCustomerDetail: async (cariKod: string) => {
        try {
          set({ isLoading: true, error: null });

          const detailUrl = 'https://bastas.duyu.alter.net.tr/PaymentCustomerGet';
          const formData = new FormData();
          formData.append('Token', 'RasyoIoToken2021');
          formData.append('CurrentCode', cariKod);

          const response = await axios.post<CariData[]>(detailUrl, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          const data = response.data;

          if (Array.isArray(data) && data.length > 0) {
            set({ customerDetail: data[0], isLoading: false });
          } else {
            set({
              error: 'Kayıt bulunamadı veya beklenmeyen veri formatı',
              isLoading: false,
              customerDetail: null
            });
          }
        } catch (err: any) {
          set({
            error: err.message || 'Cari detayı çekilirken hata oluştu',
            isLoading: false,
            customerDetail: null
          });
        }
      },

      // getInstallmentData: Seçili müşteri üzerinden TaksitSayisi bilgisini döndürür.
      getInstallmentData: () => {
        const { selectedCustomer, customerDetail } = get();
        // Öncelikle customerDetail kontrol edilebilir, yoksa selectedCustomer
        const customer = customerDetail || selectedCustomer;
        return {
          installmentCount: customer ? customer.TaksitSayisi : 1
        };
      }
    }),
    {
      name: 'customer-store',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export default useCustomerStore;
